<template>
<!-- 订单-预付款 -->
    <div class="handle-box-search preOrder">
        <div style="display: flex">
            <h4 class="nextPreh">订单预付款配置</h4>
            <span style="margin-left: 10px">配置是否让乘客在下单时对订单部分金额进行预支付</span>
        </div>

        <div class="pre-box">
            <span class="pre-span">预支付功能开启</span>
            <div class="pre-span">
                <el-switch v-model="status" inactive-text="" active-value="1" inactive-value="0"> </el-switch>
            </div>
        </div>

        <div class="pre-box">
            <div class="squ-box"></div>
            <span class="pre-span">预付金额配置</span>
        </div>

        <div>
            <span class="nextPre">当前下单模式的起步公里数以内</span>
            <el-input v-model="submit_data.kilometer_in" placeholder="起步价百分比%" class="input-pre"></el-input>
        </div>
        <div>
            <span class="nextPre">超出当前下单模式的起步公里数以外</span>
            <el-input v-model="submit_data.kilometer_out" placeholder="起步价百分比%" class="input-pre"></el-input>
        </div>
        <div class="pre-box">
            <div class="squ-box"></div>
            <span class="pre-span">乘客取消订单扣款配置</span>
        </div>
        <div>
            <span class="nextPre">司机接单后</span>
            <el-input v-model="submit_data.minute_cancel" placeholder="输入分钟" class="input-pre"></el-input
            ><span class="nextPre">分钟内取消，预付款100%返还，超时则扣除预付款</span
            ><el-input v-model="submit_data.amount_percentage" placeholder="输入数字" class="input-pre"></el-input>%
        </div>
        <div class="pre-box">
            <div class="squ-box"></div>
            <span class="pre-span">司机取消订单&后台取消订单：乘客无责，不扣除预付款</span>
        </div>
        <div class="pre-box">
            <div class="squ-box"></div>
            <span class="pre-span">乘客多次取消订单惩罚</span>
        </div>
        <div>
            <span class="nextPre">乘客24小时内连续取消</span>
            <el-input v-model="submit_data.cancel_num" placeholder="输入次数" class="input-pre"></el-input
            ><span class="nextPre">次有效司机接的订单，禁止使用代驾服务</span
            ><el-input v-model="submit_data.stop_hour" placeholder="输入时间" class="input-pre"></el-input>小时
        </div>

        <!-- 对话框底部按钮 -->

        <div style="display: flex; justify-content: center;margin-top:20px">
            <el-button type="primary" @click="onSubmitDig">保存</el-button>
        </div>
    </div>
</template>
<script>
var _this;
export default {
    data() {
        return {
            submit_url: '/AdvancePayment/editAdvancePaymentSub',
            status: 0,
            order_advance_payment_conf_code: '',
            submit_data: {
                status: 0,
                order_advance_payment_conf_code: '',
                kilometer_in: '',
                kilometer_out: '',
                minute_cancel: '',
                amount_percentage: '',
                cancel_num: '',
                stop_hour: ''
            },
            submit_rules: {
                kilometer_in: {
                    placeholder: '当前下单模式的起步公里数以内',
                    rules: {
                        required: false,
                        message: '当前下单模式的起步公里数以内为空或大于0的数字',
                        regulation: 'number',
                        rulesData: '0'
                    }
                },
                kilometer_out: {
                    placeholder: '超出当前下单模式的起步公里数以外',
                    rules: {
                        required: false,
                        message: '超出当前下单模式的起步公里数以外为空或大于0的数字',
                        regulation: 'number',
                        rulesData: 0
                    }
                },
                minute_cancel: {
                    placeholder: '司机接单后分钟',
                    rules: {
                        required: false,
                        message: '司机接单后分钟为空或大于等于0的数字',
                        regulation: 'number',
                        rulesData: 0
                    }
                },
                amount_percentage: {
                    placeholder: '超时扣除预付款',
                    rules: {
                        required: false,
                        message: '超时扣除预付款为空或大于等于0的数字',
                        regulation: 'number',
                        rulesData: 0
                    }
                },
                cancel_num: {
                    placeholder: '乘客24小时内连续取消次数',
                    rules: {
                        required: false,
                        message: '乘客24小时内连续取消次数为空或大于等于0的数字',
                        regulation: 'number',
                        rulesData: 0
                    }
                },
                stop_hour: {
                    placeholder: '禁止使用代驾服务',
                    rules: {
                        required: false,
                        message: '禁止使用代驾服务为空或大于等于0的数字',
                        regulation: 'number',
                        rulesData: 0
                    }
                }
            }
        };
    },
    created() {
        _this = this;
        _this.getAdvancePaymentDetails();
    },
    methods: {
        onSubmitDig() {
            // 注意，用postData是因为防止直接用submit_data导致输入框值默认为empty
         

            let postData = {};
            for (const key in _this.submit_data) {
                if (_this.submit_data[key] == '' || _this.submit_data[key] == '0') {
                    postData[key] = 'empty';
                    postData.status = _this.status;
                    postData.order_advance_payment_conf_code = _this.order_advance_payment_conf_code;
                } else {
                    postData[key] = _this.submit_data[key];
                }
            }

            _this.$post(_this.submit_url, postData).then((res) => {
                _this.$message.success('保存成功');

                _this.getAdvancePaymentDetails();
            });
        },

        getAdvancePaymentDetails() {
            
            _this.$post('/AdvancePayment/getAdvancePaymentDetails').then((res) => {
                _this.status = res.data.result.status.val;
                _this.order_advance_payment_conf_code = res.data.result.order_advance_payment_conf_code;
                _this.submit_data.kilometer_in = res.data.result.kilometer_in;
                _this.submit_data.kilometer_out = res.data.result.kilometer_out;
                _this.submit_data.allow_cancel_num = res.data.result.allow_cancel_num;
                _this.submit_data.minute_cancel = res.data.result.minute_cancel;
                _this.submit_data.amount_percentage = res.data.result.amount_percentage;
                _this.submit_data.cancel_num = res.data.result.cancel_num;
                _this.submit_data.stop_hour = res.data.result.stop_hour;
            });
        }
    }
};
</script>
<style scoped>
.handle-box-search {
    background-color: #fff !important;
}
.pre-box {
    display: flex;
    justify-content: start;
    margin-top: 10px;
    align-items: center;
}
.squ-box {
    background-color: #409eff;
    display: inline-block;
    width: 10px;
    height: 20px;
}
.pre-span {
    margin-left: 10px;
}
.input-pre {
    max-width: 160px !important;
    width: 60% !important;
    margin-left: 10px;
}
.nextPre {
    margin-left: 20px;
}
</style>